import { useState, useEffect } from 'react';
import SignUpPopUp from './SignUpPopUp';
import { AnimatePresence } from 'framer-motion';

import discussionIcon from "../../img/discussion.svg";
import bookIcon from "../../img/book-open.svg";


const VideoPlayerModal = ({ title, src, onClose }) => {
    const [showDiscussionPopUp, setDiscussionShowPopUp] = useState(false);
    const [showNotesPopUp,setNotesShowPopUp] = useState(false);
  
    useEffect(() => {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }, []);
  
    useEffect(() => {
      
      if (showDiscussionPopUp) {
        const timer = setTimeout(() => {
          setDiscussionShowPopUp(false);
        }, 4000);
        return () => clearTimeout(timer);
      }

      if (showNotesPopUp) {
        const timer = setTimeout(() => {
          setNotesShowPopUp(false);
        }, 4000);
        return () => clearTimeout(timer);
      }

    }, [showNotesPopUp, showNotesPopUp]);

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className="relative bg-white min-h-[370px] sm:h-fit w-full max-w-3xl rounded-xl shadow-xl overflow-hidden p-4 sm:p-6 mx-5">
        <AnimatePresence>
            {
              showDiscussionPopUp && 
              <SignUpPopUp title={'Get access to discussions!'} mobileViewTitle={'Get access to discussions!'} />
            } 
            {
              showNotesPopUp && 
              <SignUpPopUp title={'Get access to notes!'} mobileViewTitle={'Get access to notes!'} />
            } 
        </AnimatePresence>

        <div className='flex flex-col justify-between'>
          <div className='flex justify-between items-center'>
            {/* Title */}
            <div className="pb-4 border-b border-gray-200 sm:text-lg text-[16px] leading-6 font-gilroy-bold">
              {title}
            </div>
    
            {/* Close Button */}
            <button
              onClick={onClose}
              className="text-black text-xl font-bold mb-4"
              >
              ✕
            </button>
          </div>
  
          {/* Video */}
          <video
            src={src}
            controls
            autoPlay
            playsInline
            className="h-[250px] sm:w-full sm:h-full object-cover"
          />

  
          {/* Footer Actions */}
          <div className="flex items-center gap-6 pt-4 border-t border-gray-200">
              <button className="flex items-center gap-2 text-sm font-medium cursor-pointer font-gilroy-semibold" 
                  onClick={() => {
                    setDiscussionShowPopUp(true);
                  }}
                  >
                  <img src={discussionIcon} alt='Discussion Forum' height={20} width={20} /> Discussion Forum
              </button>
              <button className="flex items-center gap-2 text-sm font-medium cursor-pointer font-gilroy-semibold" 
                  onClick={() => {
                    setNotesShowPopUp(true);
                  }}
                  >
                  <img src={bookIcon} alt='Discussion Forum' height={20} width={20} /> Notes
              </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayerModal;
